import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { HistoryModel, HistoryModelImpl } from './model/history.model';
import { HistoryService, HistoryServiceImpl } from './service/history.service';
import { GetTaskIdDTO, GetHistoryListDTO, PutHistoryDTO, GetHistoryAsyncStatusListDTO, GetHistoryDetailDTO, PutHistoryReadDTO } from './service/history.repository.interface';
import { GetTaskIdDTOImpl } from './repository/get-task-id.dto';
import { GetHistoryListDTOImpl } from './repository/get-history-list.dto';
import { PutHistoryDTOImpl } from './repository/put-history.dto';
import { GetHistoryAsyncStatusListDTOImpl } from './repository/get-history-async-status-list.dto';
import { GetHistoryDetailDTOImpl } from './repository/get-history-detail.dto';
import { PutHistoryReadDTOImpl } from './repository/put-history-read.dto';

export const HistoryModule = (bind: interfaces.Bind) => {
    bind(HistoryModel).to(HistoryModelImpl);
    bind(HistoryService).to(HistoryServiceImpl);
    bind(GetTaskIdDTO).to(GetTaskIdDTOImpl);
    bind(GetHistoryListDTO).to(GetHistoryListDTOImpl);
    bind(PutHistoryDTO).to(PutHistoryDTOImpl);
    bind(GetHistoryAsyncStatusListDTO).to(GetHistoryAsyncStatusListDTOImpl);
    bind(GetHistoryDetailDTO).to(GetHistoryDetailDTOImpl);
    bind(PutHistoryReadDTO).to(PutHistoryReadDTOImpl);
};
